export default __webpack_public_path__ + "static/aluminium_prices-e0ee9fd647dbdebe40fc73fa94209140.png";